import { toFixedDecimal } from "./utils";
export default class P_GUI_OUT {
    constructor() {
        this.BSUModelVerNum = '0';
        this.BedsideControl = '0';
        this.CFEncoded = '0';
        this.CancelToken_RB = '0';
        this.DIFrame = '0';
        this.DriveStatus = '0';
        this.Frame3V = '0';
        this.Frame5V = '0';
        this.Frame36V = '0';
        this.FrameTemp = '0';
        this.FrameVerNum = '0';
        this.M1GearPos = '0';
        this.M2GearPos = '0';
        this.M2GearPosSet = '0';
        this.M3GearPos = '0';
        this.M3GearPosSet = '0';
        this.M4GearPos = '0';
        this.M4GearPosSet = '0';
    }
    static fromJson(json) {
        if (json) {
            let p_GUI_OUT = new P_GUI_OUT();
            if (json.BSUModelVerNum) {
                p_GUI_OUT.BSUModelVerNum = json.BSUModelVerNum;
            }
            if (json.BedsideControl) {
                p_GUI_OUT.BedsideControl = toFixedDecimal(json.BedsideControl);
            }
            if (json.CFEncoded) {
                p_GUI_OUT.CFEncoded = toFixedDecimal(json.CFEncoded);
            }
            if (json.CancelToken_RB) {
                p_GUI_OUT.CancelToken_RB = toFixedDecimal(json.CancelToken_RB);
            }
            if (json.DIFrame) {
                p_GUI_OUT.DIFrame = toFixedDecimal(json.DIFrame);
            }
            if (json.DriveStatus) {
                p_GUI_OUT.DriveStatus = toFixedDecimal(json.DriveStatus);
            }
            if (json.Frame3V) {
                p_GUI_OUT.Frame3V = toFixedDecimal(json.Frame3V);
            }
            if (json.Frame5V) {
                p_GUI_OUT.Frame5V = toFixedDecimal(json.Frame5V);
            }
            if (json.Frame36V) {
                p_GUI_OUT.Frame36V = toFixedDecimal(json.Frame36V);
            }
            if (json.FrameTemp) {
                p_GUI_OUT.FrameTemp = toFixedDecimal(json.FrameTemp);
            }
            if (json.FrameVerNum) {
                p_GUI_OUT.FrameVerNum = json.FrameVerNum;
            }
            if (json.M1GearPos) {
                p_GUI_OUT.M1GearPos = toFixedDecimal(json.M1GearPos);
            }
            if (json.M2GearPos) {
                p_GUI_OUT.M2GearPos = toFixedDecimal(json.M2GearPos);
            }
            if (json.M2GearPosSet) {
                p_GUI_OUT.M2GearPosSet = toFixedDecimal(json.M2GearPosSet);
            }
            if (json.M3GearPos) {
                p_GUI_OUT.M3GearPos = toFixedDecimal(json.M3GearPos);
            }
            if (json.M3GearPosSet) {
                p_GUI_OUT.M3GearPosSet = toFixedDecimal(json.M3GearPosSet);
            }
            if (json.M4GearPos) {
                p_GUI_OUT.M4GearPosSet = toFixedDecimal(json.M4GearPosSet);
            }
            return p_GUI_OUT;
        }
        return null;
    }
}
//# sourceMappingURL=P_GUI_OUT.js.map